export enum Rooms {
    One = 1,
    OneAndHalf = 1.5,
    Two = 2,
    Three = 3,
    Four = 4,
    Five = 5
}